import { get } from "./Api";
export function SearchDdlAddress({params}) {
  return get({ url: "/searchDdlAddress", params });
}

export function SearchDdlAddress2({params}) {
  return get({ url: "/searchDdlAddress2", params });
}

export function SearchDdlEvent({params}) {
  return get({ url: "/searchDdlEvent", params });
}

export function SearchAdminConfig({params}) {
  return get({ url: "/searchAdminConfig", params });
}

export function SearchTierConfig() {
  return get({ url: "/searchTierConfig" });
}

export function SearchDdlBuyFrom({params}) {
  return get({ url: `/searchDdlBuyFrom`, params});
}

export function SearchDdlBrand() {
  return get({ url: `/searchBrand`});
}

export function SearchDdlSyncProduct({params}) {
  return get({ url: `/searchSyncProduct`, params});
}

export function SearchDdlAppointmentTime() {
  return get({ url: `/searchAppointmentTime`});
}




